import AlbumGalleryCard from './AlbumGalleryCard'


export default AlbumGalleryCard
